import React from "react";
import { FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-[#0b1220] text-white pt-20 mt-24">

      <div className="max-w-7xl mx-auto px-8 grid md:grid-cols-4 gap-14">

        {/* BRAND */}
        <div>
          <h2 className="text-3xl font-bold text-red-500">
            Om Internet Services
          </h2>

          <p className="mt-5 text-gray-400 text-sm leading-relaxed">
            We are a professional IT company providing modern web development,
            mobile applications, UI/UX design and digital marketing solutions
            to help businesses grow online.
          </p>

          {/* SOCIAL */}
          <div className="flex gap-5 mt-6 text-xl">
            <FaFacebook className="hover:text-blue-500 cursor-pointer transition" />
            <FaInstagram className="hover:text-pink-500 cursor-pointer transition" />
            <FaLinkedin className="hover:text-blue-600 cursor-pointer transition" />
            <FaWhatsapp className="hover:text-green-500 cursor-pointer transition" />
          </div>
        </div>

        {/* SERVICES */}
        <div>
          <h3 className="text-lg font-semibold mb-5 text-white">
            Our Services
          </h3>

          <ul className="text-gray-400 text-sm space-y-3">
            <li className="hover:text-white cursor-pointer transition">Web Development</li>
            <li className="hover:text-white cursor-pointer transition">App Development</li>
            <li className="hover:text-white cursor-pointer transition">UI/UX Design</li>
            <li className="hover:text-white cursor-pointer transition">Digital Marketing</li>
            <li className="hover:text-white cursor-pointer transition">SEO Optimization</li>
          </ul>
        </div>

        {/* TECHNOLOGY */}
        <div>
          <h3 className="text-lg font-semibold mb-5 text-white">
            Technologies
          </h3>

          <ul className="text-gray-400 text-sm space-y-3">
            <li>React.js</li>
            <li>Node.js</li>
            <li>Express.js</li>
            <li>MongoDB</li>
            <li>Tailwind CSS</li>
          </ul>
        </div>

        {/* CONTACT */}
        <div>
          <h3 className="text-lg font-semibold mb-5 text-white">
            Contact Us
          </h3>

          <p className="text-gray-400 text-sm">
            📧 info@securewebhosting.co.in
          </p>

          <p className="text-gray-400 text-sm mt-3">
            📞 +91 78149 55755
          </p>

          <p className="text-gray-400 text-sm mt-3">
            📍 Ludhiana, Punjab, India
          </p>

          <button className="mt-6 bg-red-600 px-6 py-2 rounded-lg hover:bg-red-700 transition">
            Get Free Quote
          </button>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="border-t border-gray-700 mt-14 py-6 text-center text-gray-500 text-sm">
        © {new Date().getFullYear()} Om Internet Services. All Rights Reserved.
      </div>

    </footer>
  );
};

export default Footer;